import React from 'react';

interface InfoGroupProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * A standardized component for grouping information fields in detail views
 */
const InfoGroup: React.FC<InfoGroupProps> = ({ title, children, className = '' }) => {
  return (
    <div className={`mb-6 ${className}`}>
      {title && <h3 className="text-lg font-semibold mb-4 text-primary-charcoal">{title}</h3>}
      
      <div className="bg-accent-white p-4 rounded-md border border-primary-silver/30">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InfoGroup; 